import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateEmailTemplate$ } from "../schemas/schemas_0";
export class CreateEmailTemplateCommand extends command(_ep0, _mw0, "CreateEmailTemplate", CreateEmailTemplate$) {
}
